export default [
  {
    title: "ข้อมูลเอกสารดาวน์โหลด ",
    link: require("../../../static/pdf-template/taAssurance/taCondition1.pdf"),
    file_name: "Dummy.pdf"
  },
  {
    title: "เอกสารยินยอมเปิดเผยข้อมูลแนบคำขอ",
    link: require("../../../static/pdf-template/taAssurance/taCondition2.pdf"),
    file_name: "Dummy.pdf"
  }
]